
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs';
import {isPlatformBrowser,isPlatformServer } from '@angular/common'
import { Injectable, Inject, OnInit ,PLATFORM_ID } from '@angular/core';
import { Subject,forkJoin } from 'rxjs';
import { IuserInformation } from '../_types/userInterfaces.type';
import { ConfigurationService } from '../../_services/configuration.service';
import { map, catchError, window } from 'rxjs/operators';

import { UserProfileService } from '../../_services/user-profile.service';
import { UserProfile } from '../../_models/user-profile';

@Injectable()
export class UsersService   {
    private UserInformation: IuserInformation[] = [];
    private UserInformationSubject = new Subject();
    private CompanyGroupsSubject = new Subject();
    private ConfigSettingObj: any;
    private sub: any;
    private pollTime: number = 1000;
    messages = this.UserInformationSubject.asObservable();
    companyGroupsMessages = this.CompanyGroupsSubject.asObservable();
    timeSub: any;
    private url: string;
    private myheaders: HttpHeaders = new HttpHeaders();
    private options: any; 
    private apiurl: any;
    private up: UserProfile;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject(PLATFORM_ID) private platformid: object,
    private configurationService: ConfigurationService,private ups:UserProfileService) {
    this.url = baseUrl;
    this.ups.userProfile$.subscribe(result => {
      this.up = result;
    });
   
        this.apiurl = this.configurationService.config
        this.OnInit();
    }

    OnInit() {
        if (isPlatformBrowser(this.platformid)) { 
            this.getHeaders(null)
        }
    }

 private handleError(error: HttpResponse<any>): Observable<any> {

   let textToReturn: string;
   if (error.status == 0) {
     textToReturn = "There was an error that may result from a network connection issue.";
   } else {
    
     textToReturn = error['error'];
     textToReturn = textToReturn.replace(/^"(.+(?="$))"$/, '$1');
   }
   let text: string
   return throwError(textToReturn);
    }

    getHeaders(tok:any) {
      this.myheaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache'})
 
      let t: string = ""
      let up = this.ups.getUserProfile();
        let token: string;
        if (null == tok) {
            token = t.concat('Bearer ', String(up.token));
        } else {
            token = t.concat('Bearer ', String(tok));
        }
         
        this.myheaders.append('Authorization', token)
        this.options = ({ headers: this.myheaders });  
    }

    addUser(newCompanyUser: userProfileInfo2, company: string, password?:string): Observable<string> {
       
        this.getHeaders(null);
        return this.sub = this.http.post(this.apiurl["apiAddress"] + 'api/Companies/' + company +'/users', { "CompanyName": company, "User": newCompanyUser} ,this.options).pipe(
            map(result => {
                return "The new user was created successfully."
            }),catchError(
             this.handleError              
            )); 
    }
    
    addUser2(newUser: any, company: string, password?: string): Observable<any> {       
        this.getHeaders(null);
      delete newUser.userInfo.password;
      delete newUser.userInfo.rePassword;
      let value = forkJoin(this.userFieldAssociation(newUser.fieldIDsForACL, company, "add"), this.userWellAssociation(newUser.wellIDsForACL, company, "add"), this.userReportAssociation(newUser.reportsForACL, company,"add"))
        return this.sub = this.http.post(this.apiurl["apiAddress"] + 'api/Companies/'+company+'/users' , newUser, this.options).pipe(
            map(result => {
               return result
            }),catchError(
                this.handleError
            ));
  }

    tempUserACLAssociation(newUser: any, companyUserID:any, company: string, password?: string): Observable<any> {
    return this.sub = forkJoin(this.userFieldAssociation({ "UserIDs": [companyUserID], "ACLTypeIDs": newUser.fieldIDsForACL }, company, "add"),
      this.userWellAssociation({ "UserIDs": [companyUserID], "ACLTypeIDs": newUser.wellIDsForACL }, company, "add"),
      this.userReportAssociation({ "UserIDs": [companyUserID], "ACLTypeIDs": newUser.reportsForACL }, company, "add")).pipe(
      map(([first,second,third]) => {
        return { first, second, third};
      }), catchError(
        this.handleError
      ));

  }

    disableUsers(disabledUsers: {}, Company: string, hasPortalAccess: boolean): Observable<boolean>  {
        this.getHeaders(null);
        return this.http.put(this.apiurl["apiAddress"] + "api/companies/" + Company + "/portal-access/users?hasPortalAccess=" + hasPortalAccess,disabledUsers,this.options).pipe(
            map((result) => {
              
                return true;
            })
            ,catchError(
            this.handleError
            ));           
    }

    toggleProductioneer(disabledUsers: {}, Company: string, hasProductioneerAccess: boolean): Observable<boolean> {
        this.getHeaders(null);
        return this.http.put(this.apiurl["apiAddress"] + "api/companies/" + Company + "/productioneer-access/users?hasProductioneerAccess=" + hasProductioneerAccess, disabledUsers, this.options).pipe(
            map((result) => {

                return true
            })
            ,catchError(
                this.handleError
            ));
    }

    userGroupAssociation(userGroups: {}, company: string, edit: string): Observable<string> {
        this.getHeaders(null);
        if (edit === "add") { 
            return this.http.put(this.apiurl["apiAddress"] + "api/companies/" + company + "/groups/users", userGroups, this.options).pipe(
            map((result) => {
               
                return "User add group association successful."
            })
            ,catchError(
            this.handleError
            ));   

        }
        else {
            this.options.body = userGroups;
            return this.http.delete(this.apiurl["apiAddress"] + "api/companies/" + company + "/groups/users", this.options).pipe(
                map((result) => {
                
                    this.options.body = null;
                    return "User delete group association successful."
                })
                ,catchError(this.handleError));                                              
        }
  }

    userFieldAssociation(fieldGroups: {}, company: string, edit: string): Observable<string> {
      this.getHeaders(null);
      if (edit === "add") {
        return this.http.put(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/fields", fieldGroups, this.options).pipe(
          map((result) => {

            return "User add field association successful."
          })
          , catchError(
            this.handleError
          ));

      }
      else {
        this.options.body = fieldGroups;
        return this.http.delete(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/fields", this.options).pipe(
          map((result) => {

            this.options.body = null;
            return "User delete field association successful."
          })
          , catchError(this.handleError));
      }
  }

    userExpenditureFieldAssociation(fieldGroups: {}, company: string, edit: string): Observable<string> {
      this.getHeaders(null);
      if (edit === "add") {
        return this.http.put(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/expenditure-fields", fieldGroups, this.options).pipe(
          map((result) => {

            return "User add expenditure field association successful."
          })
          , catchError(
            this.handleError
          ));

      }
      else {
        this.options.body = fieldGroups;
        return this.http.delete(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/expenditure-fields", this.options).pipe(
          map((result) => {

            this.options.body = null;
            return "User delete expenditure field association successful."
          })
          , catchError(this.handleError));
      }
    }

    userReportAssociation(reportGroups: {}, company: string, edit: string): Observable<string> {
      this.getHeaders(null);
      if (edit === "add") {
        return this.http.put(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/reports", reportGroups, this.options).pipe(
          map((result) => {

            return "User add field association successful."
          })
          , catchError(
            this.handleError
          ));

      }
      else {
        this.options.body = reportGroups;
        return this.http.delete(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/reports", this.options).pipe(
          map((result) => {

            this.options.body = null;
            return "User delete field association successful."
          })
          , catchError(this.handleError));
      }
    }

    userWellAssociation(wellGroups: {}, company: string, edit: string): Observable<string> {
      this.getHeaders(null);
      if (edit === "add") {
        return this.http.put(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/wells", wellGroups, this.options).pipe(
          map((result) => {

            return "User add field association successful."
          })
          , catchError(
            this.handleError
          ));

      }
      else {
        this.options.body = wellGroups;
        return this.http.delete(this.apiurl["apiAddress"] + "api/companies/" + company + "/acl/wells", this.options).pipe(
          map((result) => {

            this.options.body = null;
            return "User delete field association successful."
          })
          , catchError(this.handleError));
      }
  }

    permissionCheck(company:string) {
        let t = localStorage.getItem("token");
        let permissions = [];
        if (t) {
            let token = JSON.parse(t)
            if (token["payload"]["IsSuperAdmin"]){
                permissions.push("SUPERADMIN");
            }
            for (let i = 0; i > token["claims"].lenght-1; i++) {

            }
        }
    }

    getCompanyGroups(): Observable<companyGroups[] | string>  { 
        this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + "api/companies/" + this.up.currentCompany + "/groups", this.options).pipe(
            map(result => {
        let groups = result["groups"] as companyGroups[];
        return groups

      }),catchError(this.handleError));
  }
        
    getFieldsInCompany(company:string): Observable<any> {
      this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + "api/Fields?companyname=" + company, this.options).pipe(
        map((result:any) => {

          let fields = result
          fields.forEach(f => { f.lockIcon = "fas fa-plus"})
          
          return fields

        }), catchError(this.handleError));
  }

    getReportsInCompany(company: string) {
      this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + "api/Companies/"+ company + "/reports", this.options).pipe(
        map((result: any) => {

          let reports = result
          reports.forEach(f => { f.lockIcon = "fas fa-plus" })
          return reports;

        }), catchError(this.handleError));

    }

    getUserFieldALC(username: string, company: string): Observable<any> {  
      this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + "api/Users/" + username + "/Companies/" + company + "/acl/fields", this.options).pipe(
        map((result: any) => {
          let fields = result
          fields.forEach(f => { f.lockIcon = "fas fa-minus" })
          return fields

        }), catchError(this.handleError));

    }

    getUserWellACL(username: string, company: string): Observable<any> {
      this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + "api/Users/" + username + "/Companies/" + company + "/acl/wells", this.options).pipe(      
        map((result: any) => {
        let wells = result
        wells.forEach(f => { f.lockIcon = "fas fa-minus" })
        return wells

      }), catchError(this.handleError));

  }

    getUserReportACL(username: string, company: string): Observable<any> {
    this.getHeaders(null);
    return this.http.get(this.apiurl["apiAddress"] + "api/Users/" + username + "/Companies/" + company + "/acl/reports", this.options).pipe(
      map((result: any) => {
        let reports = result
        reports.forEach(f => { f.lockIcon = "fas fa-minus" })
        return reports

      }), catchError(this.handleError));

  }

    getExpenditureFieldACL(username: string, company: string): Observable<any> {
      this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + "api/Users/" + username + "/Companies/" + company + "/acl/expenditure-fields", this.options).pipe(
        map((result: any) => {
          let fields = result
          fields.forEach(f => { f.lockIcon = "fas fa-minus" })
          return fields

        }), catchError(this.handleError));


  }

    sendPasswordResetEmail(emailAddress: string):Observable<string> {      
        this.getHeaders(null);
        var url = this.apiurl["apiAddress"] + 'api/Password/forgot-password-reset?emailAddress=' + emailAddress
      return this.sub = this.http.post(url, {}, this.options).pipe(
        map(result => {
            return "The password reset email was successfully sent to " + emailAddress
        }),catchError(this.handleError))
    }

    sendMultiplePasswordResetEmail(emailAddress: {}): Observable<EmailListSent[] | string>{
        this.getHeaders(null);
        return this.http.post(this.apiurl["apiAddress"] + 'api/Password/mulitple-password-reset', emailAddress, this.options).pipe(
            map((result:any) => {
                return result as EmailListSent[];
            }),catchError(this.handleError));       
        }

    setUserPasswordReset(user: string, password: string, isFirstTime: boolean):Observable<string> {    
      this.getHeaders(null);
     
      return this.http.post(this.apiurl["apiAddress"] + 'api/Users/' + user + '/password-reset?isFirstTime=' + isFirstTime,JSON.stringify( password), this.options).pipe(
            map(result => {
                return "Password reset was successful."
            }),catchError(this.handleError));
    }

    forgotPasswordReset(password:string,token:string):Observable<string> {
      this.getHeaders(null);
      let encodedToken = encodeURIComponent(token);
      return this.http.post(this.apiurl["apiAddress"] + 'api/Password/forget-password-update?token=' + encodedToken, JSON.stringify(password), this.options).pipe(
            map(result => {
                return "Password Reset was successful";
            })
            ,catchError(this.handleError));
    }

    getUsersInCompany(companyname: string): Observable<IuserInformation[] | string> {
        this.getHeaders(null);
      return this.sub = this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + companyname +'/users', this.options).pipe(
            map((result:any)=> {
                this.UserInformation = result as IuserInformation[] ;
                return this.UserInformation;
           }),catchError(this.handleError));

    }

    getSingleUser(username: string, company: string): Observable<IuserInformation | string> {
        this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + 'api/Users/' + username + "?companyname=" + company, this.options).pipe(
            map((result:any )=> {
        let userprofile = result as userProfileInfo2;
        return userprofile;
      })
          ,catchError(this.handleError));

    }

    singleUserProfileUpdate(userProfile: IuserInformation, company:string): Observable<string> {
        this.getHeaders(null);        
        return this.http.put(this.apiurl["apiAddress"] + 'api/Users/' + userProfile.username + "?companyname=" + company, userProfile,this.options).pipe(
            map(result => {
                return "Update user profile successful.";

            }),catchError(this.handleError));
    }

    singleUserGroupCheckList(company: string, username: string): Observable<UserGroup [] | string> {
        this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/groups/users/' + username, this.options).pipe(
            map((result:any) => {
        return result as UserGroup[]
      })
          ,catchError(this.handleError));
    }

    getVisibleACLTabs( company:string): Observable<any> {
      this.getHeaders(null);
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/acl/visible-tabs', this.options).pipe(
        map(result => {
          return result;
        })
        , catchError(this.handleError));
    }

}

interface userProfileInfo2 {
    username: string;
    fullname: string;
    email: string;
    comment: string;
    passwordQuestion: string;
    passwordAnswer: string;
    isApproved: boolean;
    lastActivityDate: Date;
    lastLoginDate: Date;
    lastPasswordChangedDate: Date;
    creationDate: Date;
    firstTime: boolean;
    hasPortalAccess: boolean;
}

interface companyGroups {
    groupID: number;
    groupName: string;
    isChecked: boolean;
}

interface userProfileInfo {
    username: string;
    fullname: string;
    email: string;
    comment: string;
    passwordQuestion: string;
    passwordAnswer: string;
    isApproved: boolean;
    lastActivityDate: Date;
    lastLoginDate: Date;
    lastPasswordChangedDate: Date;
    creationDate: Date;
    firstTime: boolean;
    isChecked: boolean;
    hasPortalAccess: boolean;
}

interface UserGroup {
    groupID: number;
    groupName: string;
}

interface EmailListSent {
    email: string;
    success: boolean;
}
